import { FC } from "react";
import { AppPartType } from "../../../types";

type Prop = {
  appPart: AppPartType;
};
const BlankSpace: FC<Prop> = () => {
  return <></>;
};

export default BlankSpace;
